import * as q from "../../queries.ts";
import type { RpcClient } from "../api.ts";
import { PagedList } from "../components/paged-list.tsx";
import { PageHeader } from "../components/page-header.tsx";
import { ActorLink } from "../components/post.tsx";
import type { ActorListKind } from "../router.ts";

export function ActorListView(
  client: RpcClient,
  actor: string,
  kind: ActorListKind,
  signal: AbortSignal,
): Element {
  const rpc = kind === "followers" ? q.getFollowers : q.getFollowing;
  return (
    <main class="actor-list-page">
      {PageHeader({
        title: kind === "followers" ? "Followers" : "Following",
        subtitle: actor.startsWith("did:") ? actor : `@${actor}`,
      })}
      {PagedList(
        async (cursor) => {
          const page = await client.call(rpc, {
            parameters: { actor, limit: 50, ...(cursor && { cursor }) },
            signal,
          });
          return { items: page.actors, ...(page.cursor && { cursor: page.cursor }) };
        },
        (entry) => entry.did,
        (entry) => <div class="actor-row">{ActorLink({ actor: entry })}</div>,
        signal,
        `No ${kind === "followers" ? "followers" : "followed accounts"} yet.`,
      )}
    </main>
  );
}
